import React from 'react'
import {useNavigate} from 'react-router-dom'
import moment from 'moment'
import type {UpcomingAppointment} from './_requests'

interface Props {
  appointments: UpcomingAppointment[]
}

const ClockIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <circle cx='12' cy='12' r='10' />
    <polyline points='12 6 12 12 16 14' />
  </svg>
)

export const UpcomingAppointmentsSidebar: React.FC<Props> = ({appointments}) => {
  const navigate = useNavigate()

  const handleViewAll = () => {
    navigate('/appointment/1')
  }

  const handleCardClick = (appointmentId: number) => {
    navigate(`/appointmentViewer/${appointmentId}`)
  }

  return (
    <div>
      <div className='cp-upcoming__header'>
        <h3 className='cp-upcoming__title'>Upcoming Appointments</h3>
        <button type='button' className='cp-upcoming__view-all' onClick={handleViewAll}>
          View all
        </button>
      </div>
      <p className='cp-upcoming__subtitle'>Next 30 days</p>

      <div className='cp-upcoming__list'>
        {appointments.length === 0 && (
          <div className='cp-empty'>No upcoming appointments</div>
        )}
        {appointments.map((appt) => {
          const start = moment(appt.startTime)
          const end = moment(appt.endTime)
          const timeStr = `${start.format('HH:mm')} - ${end.format('HH:mm')}`
          const titleStr = `${appt.serviceType} - ${appt.language}`

          return (
            <div
              key={appt.appointmentId}
              className='cp-appointment-card'
              onClick={() => handleCardClick(appt.appointmentId)}
              role='button'
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleCardClick(appt.appointmentId)
              }}
            >
              <div className='cp-appointment-card__icon'>
                <ClockIcon />
              </div>
              <div className='cp-appointment-card__body'>
                <div className='cp-appointment-card__time'>{timeStr}</div>
                <div className='cp-appointment-card__title'>{titleStr}</div>
                <div className='cp-appointment-card__location'>{appt.location}</div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
